import { use_component_is_mounted_50 } from '@/hooks/is_mounted/use_component_is_mounted_50';
import { CALLBACK__void } from '@shared/types/types';
import React from 'react';

interface Props {
  onClick?: CALLBACK__void;
}

export const ViewComponentLinePlaceholder = React.forwardRef<HTMLDivElement, Props>(({ onClick }, ref) => {
  const { is_mounted } = use_component_is_mounted_50();

  return (
    <div
      ref={ref}
      onClick={onClick}
      className={`h-10 w-full min-w-[17.5rem] flex items-center justify-center gap-2
                    bg-component text-bar-foreground px-2 ${onClick ? 'cursor-pointer' : ''} 
                    `}
    >
      <span className={`bg-component-border h-1 rounded hover-animation  ${is_mounted ? 'w-full opacity-100' : 'w-36 opacity-50'}`} />
    </div>
  );
});
